if (!customElements.get('cart-recommendations-slider')) {
  class CartRecommendationsSlider extends HTMLElement {
    constructor() {
      super();

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onClickCapture = this.onClickCapture.bind(this);
      this.preventNativeDrag = this.preventNativeDrag.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-cart-slider-viewport]');

      if (!this.viewport) return;

      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('click', this.onClickCapture, true);
      this.viewport.addEventListener('dragstart', this.preventNativeDrag);
    }

    disconnectedCallback() {
      this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport?.removeEventListener('pointermove', this.onPointerMove);
      this.viewport?.removeEventListener('pointerup', this.onPointerUp);
      this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
      this.viewport?.removeEventListener('click', this.onClickCapture, true);
      this.viewport?.removeEventListener('dragstart', this.preventNativeDrag);
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      this.dragPointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragStartScroll = this.viewport.scrollLeft;
      this.hasDragged = false;
    }

    onPointerMove(event) {
      if (event.pointerId !== this.dragPointerId) return;

      const distance = event.clientX - this.dragStartX;
      if (!this.hasDragged && Math.abs(distance) > 4) {
        this.hasDragged = true;
        this.viewport.setPointerCapture(event.pointerId);
        this.viewport.classList.add('is-dragging');
      }

      if (!this.hasDragged) return;

      event.preventDefault();
      this.viewport.scrollLeft = this.dragStartScroll - distance;
    }

    onPointerUp(event) {
      if (event.pointerId !== this.dragPointerId) return;

      if (this.viewport.hasPointerCapture(event.pointerId)) {
        this.viewport.releasePointerCapture(event.pointerId);
      }

      this.suppressClick = this.hasDragged;
      this.dragPointerId = null;
      this.viewport.classList.remove('is-dragging');

      window.setTimeout(() => {
        this.suppressClick = false;
      }, 0);
    }

    onClickCapture(event) {
      if (!this.suppressClick) return;

      event.preventDefault();
      event.stopPropagation();
    }

    preventNativeDrag(event) {
      event.preventDefault();
    }
  }

  customElements.define('cart-recommendations-slider', CartRecommendationsSlider);
}
